/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Filter_AllInputs */

const en_blog_filter_all = /** @type {(inputs: Blog_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All articles`)
};

const lv_blog_filter_all = /** @type {(inputs: Blog_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visi raksti`)
};

/**
* | output |
* | --- |
* | "All articles" |
*
* @param {Blog_Filter_AllInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_filter_all = /** @type {((inputs?: Blog_Filter_AllInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Filter_AllInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_filter_all(inputs)
	return en_blog_filter_all(inputs)
});